import React, { useEffect, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import properties from "../../../apiConfigs/properties";
import Button from "../../../designComponents/Button";
import Checkbox from "../../../designComponents/Checkbox";
import Typography from "../../../designComponents/Typography";
import requestAPI from "../../../utils/requestAPI";
type PropertyDetailsType = {
  property: Property;
  nearbyPlaces: [];
};
interface Property {
  _id: string;
  address: string;
  area: string;
  bathrooms: number;
  bedrooms: number;
  createdAt: string;
  description: string;
  images: string[];
  landlord: Landlord;
  location: Location;
  pricing: Pricing;
  status: string;
  updatedAt: string;
  similarProperties: SimilarProperty[];
  allowBidding: boolean;
  amenities: Amenity[];
  policy: Policy[];
  refRoom: RefRoom;
  rules: string[];
}

interface Landlord {
  _id: string;
  avatar: string;
  firstName: string;
  lastName: string;
  email: string;
}

interface Location {
  type: string;
  coordinates: number[];
}

interface Pricing {
  priceType: string;
  price: number;
}

interface SimilarProperty {
  _id: string;
  address: string;
  images: string[];
  pricing: Pricing;
}

interface Amenity {
  title: string;
  icon: string;
}

interface Policy {
  rule: string;
  description: string;
}

interface RefRoom {
  images: string[];
}
const Wrapper = styled.div`
  max-width: 1200px;
  .property-details {
    display: flex;
    flex-direction: column;
  }

  .carousel-container {
    width: 100%;
    max-width: 1200px;
  }

  .carousel-item {
    margin: 0 0px 0 0;
  }

  .carousel-image {
    width: 100%;
    height: 300px;
    object-fit: cover;
    border-radius: 5px;
  }

  .alice-carousel__stage-item {
    padding: 5px;
  }
`;
function Review() {
  const navigate = useNavigate();
  const { propertyId } = useParams();
  const [propertyDetail, setPropertyDetail] = useState<PropertyDetailsType>();
  const [loading, setLoading] = useState<boolean>(false);
  const [propertyReviewReport, setPropertyReviewReport] = useState<{
    images: { action: "accept" | "reject" | ""; reason: string };
    refImages: { action: "accept" | "reject" | ""; reason: string };
    description: { action: "accept" | "reject" | ""; reason: string };
    rules: { action: "accept" | "reject" | ""; reason: string };
    amenities: { action: "accept" | "reject" | ""; reason: string };
  }>({
    images: { action: "", reason: "" },
    refImages: { action: "", reason: "" },
    description: { action: "", reason: "" },
    rules: { action: "", reason: "" },
    amenities: { action: "", reason: "" },
  });
  const getPropertyDetails = async (id: string) => {
    setLoading(true);
    try {
      const response = await requestAPI(properties.getSingleProperty(id));
      setPropertyDetail(response);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  // const submitReview = async () => {
  //   setLoading(true);
  //   try {
  //     await requestAPI(
  //       properties.reviewProperty(propertyId as string, {
  //         action:
  //           propertyReviewReport.images.action === "accept" &&
  //           propertyReviewReport.rules.action === "accept" &&
  //           propertyReviewReport.amenities.action === "accept" &&
  //           propertyReviewReport.description.action === "accept"
  //             ? "accept"
  //             : "reject",
  //         additionalDetails: [
  //           {
  //             type: "Property Images",
  //             reason: propertyReviewReport.images.reason,
  //           },
  //           {
  //             type: "Property Description",
  //             reason: propertyReviewReport.description.reason,
  //           },
  //           {
  //             type: "Property Rules",
  //             reason: propertyReviewReport.rules.reason,
  //           },
  //           {
  //             type: "Property Amenities",
  //             reason: propertyReviewReport.amenities.reason,
  //           },
  //         ],
  //       })
  //     );

  //     toast.success("Review posted successfully");
  //     setLoading(false);
  //   } catch (e: any) {
  //     console.log(e.message);
  //     setLoading(false);
  //   }
  // };
  const handleDragStart = (e: React.DragEvent<HTMLImageElement>) =>
    e.preventDefault();

  const propertyImageItems = propertyDetail?.property?.images?.map(
    (image, index) => (
      <div key={index} className="carousel-item">
        <img
          src={image}
          onDragStart={handleDragStart}
          alt="properties images"
          role="presentation"
          className="carousel-image"
        />
      </div>
    )
  );
  const propertyRefImageItems = propertyDetail?.property?.refRoom?.images?.map(
    (image, index) => (
      <div key={index} className="carousel-item">
        <img
          src={image}
          onDragStart={handleDragStart}
          alt="properties images"
          role="presentation"
          className="carousel-image"
        />
      </div>
    )
  );

  useEffect(() => {
    if (propertyId) {
      getPropertyDetails(propertyId);
    }
  }, []);
  if (loading === true) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Typography>Loading..</Typography>
      </div>
    );
  }

  return (
    <Wrapper style={{}}>
      <div>
        <Typography size={"h3"} fontWeight="medium">
          {" "}
          Review Screen
        </Typography>
      </div>

      <div
        className="image-review"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "10px",
          alignItems: "flex-start",
          backgroundColor: "white",
          padding: 20,
          borderRadius: 6,
          marginBottom: 10,
        }}
      >
        <Typography size={"h4"} fontWeight="normal" style={{}}>
          {" "}
          Property Images
        </Typography>
        <div className="carousel-container" style={{ flex: "1 1 100%" }}>
          <AliceCarousel
            mouseTracking
            items={propertyImageItems}
            responsive={{
              0: { items: 1 },
              768: { items: 2 },
              1024: { items: 3 },
            }}
            controlsStrategy="alternate"
            disableButtonsControls
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            justifyContent: "space-between",
            flex: "1 1 100%",
          }}
        >
          <Typography size={"h5"} fontWeight="medium">
            Actions
          </Typography>

          <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
            <div>
              <Typography style={{ color: "#555A77" }}>Accept</Typography>
              <Checkbox
                checked={propertyReviewReport.images.action === "accept"}
                onChange={() => {
                  setPropertyReviewReport({
                    ...propertyReviewReport,
                    images: {
                      action: "accept",
                      reason: propertyReviewReport.images.reason,
                    },
                  });
                }}
              />
            </div>

            <div>
              <Typography style={{ color: "#555A77" }}>Reject</Typography>
              <Checkbox
                checked={propertyReviewReport.images.action === "reject"}
                onChange={() => {
                  setPropertyReviewReport({
                    ...propertyReviewReport,
                    images: {
                      action: "reject",
                      reason: propertyReviewReport.images.reason,
                    },
                  });
                }}
              />
            </div>
          </div>

          {/* Textarea */}
          {propertyReviewReport.images.action === "reject" && (
            <textarea
              style={{
                backgroundColor: "#E3DFF6",
                marginTop: "10px",
                width: "100%",
                maxWidth: "450px",
                minHeight: "150px",
                resize: "vertical",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              placeholder="Please provide a reason for rejection..."
              onChange={(e) => {
                setPropertyReviewReport({
                  ...propertyReviewReport,
                  images: {
                    action: propertyReviewReport.images.action,
                    reason: e.target.value,
                  },
                });
              }}
            />
          )}
        </div>
      </div>
      {propertyDetail &&
        propertyDetail?.property?.refRoom?.images?.length > 0 && (
          <>
            <div
              className="image-review"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "30px",
                alignItems: "flex-start",
                backgroundColor: "white",
                padding: 20,
                borderRadius: 6,
              }}
            >
              <Typography
                size={"h4"}
                fontWeight="normal"
                style={{ paddingTop: 10 }}
              >
                {" "}
                Property Reference Images
              </Typography>
              <div className="carousel-container" style={{ flex: "1 1 100%" }}>
                <AliceCarousel
                  mouseTracking
                  items={propertyRefImageItems}
                  responsive={{
                    0: { items: 1 },
                    768: { items: 2 },
                    1024: { items: 3 },
                  }}
                  controlsStrategy="alternate"
                  disableButtonsControls
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  justifyContent: "space-between",
                  flex: "1 1 100%",
                }}
              >
                <Typography size={"h5"} fontWeight="medium">
                  Actions
                </Typography>

                <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                  <div>
                    <Typography style={{ color: "#555A77" }}>Accept</Typography>
                    <Checkbox
                      checked={
                        propertyReviewReport.refImages.action === "accept"
                      }
                      onChange={() => {
                        setPropertyReviewReport({
                          ...propertyReviewReport,
                          refImages: {
                            action: "accept",
                            reason: propertyReviewReport.refImages.reason,
                          },
                        });
                      }}
                    />
                  </div>

                  <div>
                    <Typography style={{ color: "#555A77" }}>Reject</Typography>
                    <Checkbox
                      checked={
                        propertyReviewReport.refImages.action === "reject"
                      }
                      onChange={() => {
                        setPropertyReviewReport({
                          ...propertyReviewReport,
                          refImages: {
                            action: "reject",
                            reason: propertyReviewReport.refImages.reason,
                          },
                        });
                      }}
                    />
                  </div>
                </div>

                {/* Textarea */}
                {propertyReviewReport.refImages.action === "reject" && (
                  <textarea
                    style={{
                      backgroundColor: "#E3DFF6",
                      marginTop: "10px",
                      width: "100%", // Make the textarea take full width of its parent container
                      maxWidth: "450px", // Limit max width to 450px
                      minHeight: "150px",
                      resize: "vertical",
                      padding: "10px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                    placeholder="Please provide a reason for rejection..."
                    onChange={(e) => {
                      setPropertyReviewReport({
                        ...propertyReviewReport,
                        refImages: {
                          action: propertyReviewReport.refImages.action,
                          reason: e.target.value,
                        },
                      });
                    }}
                  />
                )}
              </div>
            </div>
          </>
        )}
      <div
        style={{
          paddingTop: 20,
          flexDirection: "column",
          display: "flex",
          backgroundColor: "white",
          padding: 20,
          borderRadius: 6,
        }}
      >
        <Typography size={"h4"} fontWeight="medium">
          Description
        </Typography>
        <Typography>{propertyDetail?.property?.description}</Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            justifyContent: "space-between",
            flex: "1 1 100%",
          }}
        >
          <Typography
            size={"h5"}
            style={{ paddingTop: 10 }}
            fontWeight="medium"
          >
            Actions
          </Typography>

          <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
            <div>
              <Typography style={{ color: "#555A77" }}>Accept</Typography>
              <Checkbox
                checked={propertyReviewReport.description.action === "accept"}
                onChange={() => {
                  setPropertyReviewReport({
                    ...propertyReviewReport,
                    description: {
                      action: "accept",
                      reason: propertyReviewReport.description.reason,
                    },
                  });
                }}
              />
            </div>

            <div>
              <Typography style={{ color: "#555A77" }}>Reject</Typography>
              <Checkbox
                checked={propertyReviewReport.description.action === "reject"}
                onChange={() => {
                  setPropertyReviewReport({
                    ...propertyReviewReport,
                    description: {
                      action: "reject",
                      reason: propertyReviewReport.description.reason,
                    },
                  });
                }}
              />
            </div>
          </div>

          {/* Textarea */}
          {propertyReviewReport.description.action === "reject" && (
            <textarea
              style={{
                backgroundColor: "#E3DFF6",
                marginTop: "10px",
                width: "100%", // Make the textarea take full width of its parent container
                maxWidth: "450px", // Limit max width to 450px
                minHeight: "150px",
                resize: "vertical",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              placeholder="Please provide a reason for rejection..."
              onChange={(e) => {
                setPropertyReviewReport({
                  ...propertyReviewReport,
                  description: {
                    action: propertyReviewReport.description.action,
                    reason: e.target.value,
                  },
                });
              }}
            />
          )}
        </div>
      </div>
      <div
        style={{
          marginTop: 20,
          flexDirection: "column",
          display: "flex",
          backgroundColor: "white",
          padding: 20,
          borderRadius: 6,
        }}
      >
        <Typography size={"h4"} fontWeight="medium">
          Rules
        </Typography>
        {propertyDetail?.property?.rules?.map((item: any, index) => {
          return (
            <div key={index} style={{ display: "flex", gap: 10 }}>
              <Typography>{index + 1}. </Typography>
              <div>
                <Typography size={"h4"} style={{ color: "#3F3F3F" }}>
                  {item?.title}.{" "}
                </Typography>
                <Typography size={"h5"} style={{ color: "#5F5F5F" }}>
                  {item?.description}.{" "}
                </Typography>
              </div>
            </div>
          );
        })}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            justifyContent: "space-between",
            flex: "1 1 100%",
          }}
        >
          <Typography
            size={"h5"}
            style={{ paddingTop: 10 }}
            fontWeight="medium"
          >
            Actions
          </Typography>

          <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
            <div>
              <Typography style={{ color: "#555A77" }}>Accept</Typography>
              <Checkbox
                checked={propertyReviewReport.rules.action === "accept"}
                onChange={() => {
                  setPropertyReviewReport({
                    ...propertyReviewReport,
                    rules: {
                      action: "accept",
                      reason: propertyReviewReport.rules.reason,
                    },
                  });
                }}
              />
            </div>

            <div>
              <Typography style={{ color: "#555A77" }}>Reject</Typography>
              <Checkbox
                checked={propertyReviewReport.rules.action === "reject"}
                onChange={() => {
                  setPropertyReviewReport({
                    ...propertyReviewReport,
                    rules: {
                      action: "reject",
                      reason: propertyReviewReport.rules.reason,
                    },
                  });
                }}
              />
            </div>
          </div>

          {/* Textarea */}
          {propertyReviewReport.rules.action === "reject" && (
            <textarea
              style={{
                backgroundColor: "#E3DFF6",
                marginTop: "10px",
                width: "100%", // Make the textarea take full width of its parent container
                maxWidth: "450px", // Limit max width to 450px
                minHeight: "150px",
                resize: "vertical",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              placeholder="Please provide a reason for rejection..."
              onChange={(e) => {
                setPropertyReviewReport({
                  ...propertyReviewReport,
                  rules: {
                    action: propertyReviewReport.rules.action,
                    reason: e.target.value,
                  },
                });
              }}
            />
          )}
        </div>
      </div>
      <div
        style={{
          marginTop: 20,
          flexDirection: "column",
          display: "flex",
          backgroundColor: "white",
          padding: 20,
          borderRadius: 6,
          gap: 20,
        }}
      >
        <Typography size={"h4"} fontWeight="medium">
          Amenities
        </Typography>
        {propertyDetail?.property?.amenities?.map((item: any, index) => {
          return (
            <div
              key={index}
              style={{ display: "flex", gap: 10, alignItems: "center" }}
            >
              <img
                src={item.icon}
                style={{ width: 40, height: 40, borderRadius: 50 }}
              ></img>
              <div>
                <Typography size={"h4"} style={{ color: "#3F3F3F" }}>
                  {item?.title}.{" "}
                </Typography>
              </div>
            </div>
          );
        })}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            justifyContent: "space-between",
            flex: "1 1 100%",
          }}
        >
          <Typography
            size={"h5"}
            style={{ paddingTop: 10 }}
            fontWeight="medium"
          >
            Actions
          </Typography>

          <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
            <div>
              <Typography style={{ color: "#555A77" }}>Accept</Typography>
              <Checkbox
                checked={propertyReviewReport.amenities.action === "accept"}
                onChange={() => {
                  setPropertyReviewReport({
                    ...propertyReviewReport,
                    amenities: {
                      action: "accept",
                      reason: propertyReviewReport.amenities.reason,
                    },
                  });
                }}
              />
            </div>

            <div>
              <Typography style={{ color: "#555A77" }}>Reject</Typography>
              <Checkbox
                checked={propertyReviewReport.amenities.action === "reject"}
                onChange={() => {
                  setPropertyReviewReport({
                    ...propertyReviewReport,
                    amenities: {
                      action: "reject",
                      reason: propertyReviewReport.amenities.reason,
                    },
                  });
                }}
              />
            </div>
          </div>

          {/* Textarea */}
          {propertyReviewReport.amenities.action === "reject" && (
            <textarea
              style={{
                backgroundColor: "#E3DFF6",
                marginTop: "10px",
                width: "100%", // Make the textarea take full width of its parent container
                maxWidth: "450px", // Limit max width to 450px
                minHeight: "150px",
                resize: "vertical",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              placeholder="Please provide a reason for rejection..."
              onChange={(e) => {
                setPropertyReviewReport({
                  ...propertyReviewReport,
                  amenities: {
                    action: propertyReviewReport.amenities.action,
                    reason: e.target.value,
                  },
                });
              }}
            />
          )}
        </div>
      </div>
      <div style={{ marginTop: 25 }}>
        <Button
          onClick={() => {
            // submitReview();
          }}
          style={{ color: "#806ED8", background: "#E3DFF6", borderRadius: 6 }}
        >
          Submit Review{" "}
        </Button>
      </div>
    </Wrapper>
  );
}

export default Review;
